const styles = ({ BREAKPOINTS }) => ({
  container: {
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    '& button': {
      display: 'inline',
      margin: 0,
      padding: 0,
      fontSize: '30px',
      color: '#fff',
      '&:hover': {
        opacity: '0.8'
      }
    }
  },
  hiddenMobile: {
    display: 'none',
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      display: 'inline'
    }
  }
})

export default styles
